import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import { auth, database } from "../../../utils/firebase";
import {onValue, ref} from "firebase/database";
import { useEffect, useState } from "react";
import {
    Avatar,
    Card,
    CardContent,
    Chip,
    Typography
} from "@mui/joy";
import SuccessAlert from "../../reusable_elements/SuccessAlert";
import {CopyBlock} from "react-code-blocks";

const LeagueAccessPost = () => {
    const navigate = useNavigate();
    const { appId, leagueId } = useParams();
    const [appName, setAppName] = useState("");
    const [appLogoUrl, setAppLogoUrl] = useState("");
    const [appDescription, setAppDescription] = useState("");
    const [appVerified, setAppVerified] = useState(false);
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [redirect, setRedirect] = useState("");

    useEffect(() => {
        const appRef = ref(database, `LID/apps/${appId}`);
        onValue(appRef, (snapshot) => {
            const appData = snapshot.val();
            setAppName(appData.appName);
            setAppLogoUrl(appData.appLogoUrl);
            setAppDescription(appData.appDescription);
            setAppVerified(appData.verified);
            setSuccessAlertOpen(true);
            setRedirect(appData.redirect);
            setTimeout(() => {
                if (appData.redirect !== "id") {
                    navigate(appData.redirect);
                }
                setSuccessAlertOpen(false);
            }, 5000);
        }, (error) => {
            console.error("Error fetching app data:", error);
        });
    }, [appId]);

    const handleCloseSuccessAlert = () => {
        setSuccessAlertOpen(false);
    }

    return (
        <div className="container" style={{ display: 'flex', justifyContent: 'center'}}>
            <Card sx={{ width: 320, maxWidth: '100%', boxShadow: 'lg' }}>
                <CardContent sx={{ alignItems: 'center', textAlign: 'center' }}>
                    <Typography component="p">Connection Successful.</Typography>
                    <Avatar src={appLogoUrl} sx={{ '--Avatar-size': '4rem' }} />
                    {appVerified && (
                        <Chip
                            size="sm"
                            variant="soft"
                            color="primary"
                            sx={{
                                mt: -1,
                                mb: 1,
                                border: '3px solid',
                                borderColor: 'background.surface',
                            }}
                        >
                            Verified
                        </Chip>
                    )}
                    <Typography level="title-lg">{appName}</Typography>
                    <Typography level="body-sm" sx={{ maxWidth: '24ch' }}>
                        {appDescription}
                    </Typography>
                    <br/>
                    <Typography level="body-sm">
                        {appName} is now allowed to access and change your league's data.
                    </Typography>
                    <br/>
                    {redirect === "id" ? (
                        <div>
                            <Typography level="body-sm">
                                {appName} has requested that you provide them with your league ID:
                            </Typography>
                            <CopyBlock
                                language={"text"}
                                theme="dracula"
                                text={leagueId}/>
                        </div>
                    ) : (
                        <Typography level="body-sm">
                            You will be redirected shortly.
                        </Typography>
                    )}
                </CardContent>
            </Card>
            {successAlertOpen &&
                <div>
                    <SuccessAlert message={"Successfully connected app"} onClose={handleCloseSuccessAlert} />
                </div>
            }
        </div>
    )
}

export default LeagueAccessPost;